import { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [copyright, setCopyright] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const defaultTitle = "ПО РСО - система оповещения и информирования";
  const defaultCopyright = "";
  const currentYear = new Date().getFullYear();
  const numStars = 300;

  const asciiLogo = `
    ██████╗  ██████╗     ██████╗ ███████╗ ██████╗ 
    ██╔══██╗██╔═══██╗    ██╔══██╗██╔════╝██╔═══██╗
    ██████╔╝██║   ██║    ██████╔╝███████╗██║   ██║
    ██╔═══╝ ██║   ██║    ██╔══██╗╚════██║██║   ██║
    ██║     ╚██████╔╝    ██║  ██║███████║╚██████╔╝
    ╚═╝      ╚═════╝     ╚═╝  ╚═╝╚══════╝ ╚═════╝ 
  `;

  useEffect(() => {
    setFavicon();
    
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      createStars();
      setTexts();
    }
  }, [isLoading]);

  const setTexts = () => {
    document.title = defaultTitle;
    setCopyright(`© ${currentYear} ПО "РСО" ${defaultCopyright}`);
  };

  const setFavicon = () => {
    const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
    favicon.type = 'image/x-icon';
    favicon.rel = 'icon';
    favicon.href = '/favicon.ico';
    document.head.appendChild(favicon);
  };

  const createStars = () => {
    const starsContainer = document.getElementById('stars');
    if (!starsContainer) return;

    for (let i = 0; i < numStars; i++) {
      const star = document.createElement('div');
      star.classList.add('star');
      star.style.top = `${Math.random() * 120}%`;
      star.style.left = `${Math.random() * 100}%`;
      const size = Math.random() * 1.2 + 0.8;
      star.style.width = `${size}px`;
      star.style.height = `${size}px`;
      star.style.background = '#fff';
      star.style.animation = `moveUp ${Math.random() * 40 + 20}s linear infinite`;
      starsContainer.appendChild(star);

      star.addEventListener('animationiteration', () => {
        star.style.top = '110%';
        star.style.left = `${Math.random() * 100}%`;
      });
    }
  };

  const handleDocumentation = () => {
    window.location.href = '/folder/index.html';
  };

  const handleDownload = () => {
    window.location.href = '/files/kaik.zip';
  };

  if (isLoading) {
    return (
      <div className="preloader">
        <div className="preloader-content">
          <pre className="ascii-logo">{asciiLogo}</pre>
          <div className="loading-text">
            <div className="system-info">
              <div>{'>'} Система РСО v2.1.3</div>
              <div>{'>'} Инициализация компонентов...</div>
              <div>{'>'} Загрузка модулей ядра...</div>
              <div>{'>'} Старт сервиса...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="logo ">ПО "РСО"</div>
      <div className="stars" id="stars"></div>
      
      <main>
        <div className="container">
          <section className="hero">
            <h1 className="title">
              <span className="title-highlight">Система оповещения</span>
              <br />
              <span>и информирования</span>
            </h1>
            <div className="divider"></div>
            
          
              <button className="btn btn-lg btn-secondary" onClick={handleDocumentation}>
                <span className="btn-bracket">[</span>
                Документация
                <span className="btn-bracket">]</span>
              </button>
            
           
          </section>

          <section className="contacts">
            <h2 className="contacts-title">
              <span className="section-number">01.</span> Контактная информация
            </h2>
            
            <div className="contacts-grid">
              <div className="contact-card">
                <div className="contact-header">
                  <span className="contact-number">[01]</span>
                  <span className="contact-type">ТЕЛ.</span>
                </div>
                <div className="contact-content">
                  <span className="contact-label">Позвонить нам</span>
                  <span className="contact-value">(861) 205-10-43</span>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-header">
                  <span className="contact-number">[02]</span>
                  <span className="contact-type">ПОЧТА</span>
                </div>
                <div className="contact-content">
                  <span className="contact-label">Написать нам</span>
                  <span className="contact-value">office@sotcom-yug.ru</span>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-header">
                  <span className="contact-number">[03]</span>
                  <span className="contact-type">АДРЕС</span>
                </div>
                <div className="contact-content">
                  <span className="contact-label">Найти нас</span>
                  <span className="contact-value">
                    350072, г. Краснодар,<br />
                    ул. Ростовское шоссе, 14Б, оф. 8
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <footer>
        <div className="footer-line"></div>
        <p className="copyright">
          <span className="footer-prefix">СИСТЕМА:</span> {copyright} НАХОДИТСЯ В РЕЕСТРЕ РОССИЙСКОГО ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ <a href="https://reestr.digital.gov.ru/reestr/3508313/" target="blank_" style={{color: '#66ff66', fontSize: '15px'}}>№28901</a>.  
        </p>
      </footer>
    </div>
  );
};

export default App;
